type AlertType = 'error' | 'question' | 'success' | 'info' | 'warning';

type AlertInput =
  | 'text'
  | 'email'
  | 'password'
  | 'number'
  | 'tel'
  | 'select'
  | 'radio'
  | 'checkbox'
  | 'textarea'
  | 'file'
  | 'url';

/**
 * Os motivos que podem chamar o onCancel
 */
// export const DismissReason = {
//   ...swal.DismissReason
// };
export enum AlertDismissReason {
  backdrop = 'overlay',
  cancel = 'cancel',
  close = 'close',
  esc = 'esc',
  timer = 'timer'
}

type AlertActions = {
  onConfirm?: (value?: any) => any;
  onCancel?: (value?: any, dismiss?: AlertDismissReason) => any;
};

export type AlertProps = AlertActions & {
  type: AlertType;
  title?: string;
  showCancelButton?: boolean;
  showConfirmButton?: boolean;
  cancelButtonText?: string;
  cancelButtonColor?: string;
  confirmButtonColor?: string;
  confirmButtonText?: string;
  input?: AlertInput;
  timer?: number;
  text?: string;
  inputPlaceholder?: string;
  inputValidator?: any;
  inputOptions?: Record<string, string>;
  html?: any;
  acceptEmptyString?: boolean;
};
